import { OptionsFilter } from '@mantine/core';

export const filterTariffOptions: OptionsFilter = ({ options, search }) => {
  const normalizedSearch = search.trim().toLowerCase();
  if (!normalizedSearch) {
    return options;
  }

  return options.filter((option: any) => {
    const haystack = [
      option.label,
      option.code,
      option.description,
      option.value,
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return normalizedSearch.split(/\s+/).every((term) => haystack.includes(term));
  });
};
